import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import styles from './badge.css'

function TileBadge({
  title, hide, gridBadge, isRental, darkBackground
}) {
  return (
    <div
      className={classnames(styles.badgeWrapper, {
        [styles.hide]: hide,
        [styles.gridBadge]: gridBadge
      })}
    >
      <div
        className={classnames(styles.badge, styles.roundedBadge, {
          [styles.isRental]: isRental,
          [styles.darkBackground]: darkBackground
        })}
      >
        {title}
      </div>
    </div>
  )
}

TileBadge.propTypes = {
  title: PropTypes.string.isRequired,
  hide: PropTypes.bool,
  gridBadge: PropTypes.bool,
  isRental: PropTypes.bool,
  darkBackground: PropTypes.bool
}

TileBadge.defaultProps = {
  hide: false,
  gridBadge: false,
  isRental: false,
  darkBackground: false
}

export default TileBadge
